export default "__VITE_ASSET__4cEml3PH__"